import axios from 'axios';

export default {
  // Sales multi-customer endpoints
  index: (params = {}, config = {}) => axios.get('sales-multi-customers', { params, ...config }),
  store: (data = {}) => axios.post('sales-multi-customers', data),
  update: (saleId, data = {}, config = {}) => axios.put(`sales-multi-customers/${saleId}`, data, config),
  updateStatus: (saleId, data = {}, config = {}) => axios.put(`sales-multi-customers/${saleId}/status`, data, config),
  delete: (saleId, config = {}) => axios.delete(`sales-multi-customers/${saleId}`, config),
  flatRates: (data = {}) => axios.post('sales/igualas', data),
  metrics: (params = {}, config = {}) => axios.get('sales-multi-customers/metrics', { params, ...config }),
  paymentFlow: (saleId, params = {}, config = {}) => axios.get(`sales-multi-customers/${saleId}/payment-flow`, { params, ...config }),
  progress: (saleId, params = {}, config = {}) => axios.get(`sales-multi-customers/${saleId}/progress`, { params, ...config }),
  documentsIndex: (saleId, params = {}, config = {}) => axios.get(`sales-multi-customers/${saleId}/documents`, { params, ...config }),
  documentsStore: (saleId, payload = {}, config = {}) => axios.post(`sales-multi-customers/${saleId}/documents`, payload, config),
  documentsUpdate: (saleId, documentId, payload = {}, config = {}) => axios.put(`sales-multi-customers/${saleId}/documents/${documentId}`, payload, config),
  documentsDelete: (saleId, documentId, config = {}) => axios.delete(`sales-multi-customers/${saleId}/documents/${documentId}`, config),
  documentsDownloadAll: (saleId, params = {}, config = {}) => axios.get(
    `sales-multi-customers/${saleId}/documents/download-all`,
    {
      params,
      responseType: 'blob',
      ...config,
    },
  ),
  customers: (saleId, params = {}, config = {}) => axios.get(`sales-multi-customers/${saleId}/customers`, { params, ...config }),
  customersMetrics: (saleId, params = {}, config = {}) => axios.get(`sales-multi-customers/${saleId}/customers/metrics`, { params, ...config }),
  customerAccountStatementExcel: (saleId, customerId, config = {}) => axios.get(
    `sales-multi-customers/${saleId}/customers/${customerId}/account-statement/excel`,
    {
      responseType: 'blob',
      ...config,
    },
  ),
  customerAccountStatementPdf: (saleId, customerId, config = {}) => axios.get(
    `sales-multi-customers/${saleId}/customers/${customerId}/account-statement/pdf`,
    {
      responseType: 'blob',
      ...config,
    },
  ),
  addCustomers: (saleId, data = {}, config = {}) => axios.post(`sales-multi-customers/${saleId}/customers`, data, config),
  clearCustomersWithoutPlans: (saleId, config = {}) => axios.delete(`sales-multi-customers/${saleId}/customers`, config),
  deleteCustomer: (saleId, customerId, config = {}) => axios.delete(`sales-multi-customers/${saleId}/customers/${customerId}`, config),

  // Sales support endpoints
  saleCode: (params = {}, config = {}) => axios.get('consecutives/sale-code', { params, ...config }),

  // Catalog endpoints
  statuses: (params = {}, config = {}) => axios.get('sale-statuses', { params, ...config }),
};
